var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 399,
    height: 80,
    viewBox: "0 0 399 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.115967 1C1.04948 8.56499 5.32171 21.6174 16.9407 26C29.6663 30.8 132.678 62.3333 182.593 77.5C186.798 78.6667 198.281 80.3 210.567 77.5C222.854 74.7 327.219 42 377.865 26C384.174 23.9232 396.632 16.0889 398.041 1H0.115967Z",
    fill: "#294256"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 2C31.5 5.5 29.5 6.5 46.3922 14C61.7667 20.8262 151.525 44.1667 193.943 56.5C197.235 57.8333 206.888 59.7 219.175 56.5C231.462 53.3 322.662 26.8333 366.726 14C373.126 12 378.5 8.5 386 1.5",
    stroke: "url(#paint0_linear_203_62)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_62",
    x1: 206.011,
    y1: 58,
    x2: 206.011,
    y2: -6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AC541"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AC541",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/CardArrow.0d804cb64c82b579befbb98b97d47457.svg";
export { ForwardRef as ReactComponent };